import React from 'react';

import GeneralConditions from './contents/GeneralConditions';

const SolicitudAside = () => {
  return <GeneralConditions />;
};

export default SolicitudAside
